import React from 'react';
import { Home, Search, Heart, GitCompareArrows, User } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const items = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Search, label: 'Search', path: '/search' },
  { icon: Heart, label: 'Favorites', path: '/dashboard?tab=favorites' },
  { icon: GitCompareArrows, label: 'Compare', path: '/compare' },
  { icon: User, label: 'Profile', path: '/dashboard' },
];

export const BottomNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background md:hidden" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex items-center justify-around h-14">
        {items.map((item) => {
          const active = pathname === item.path || (item.path === '/' && pathname === '/');
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center gap-0.5 text-xs transition-colors ${
                active ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
